/* eslint-disable no-redeclare */
/* eslint-disable @typescript-eslint/no-namespace */
export const TextStyle_TextAlignment = {
    AUTO: 'AUTO',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
    CENTER: 'CENTER',
    JUSTIFY: 'JUSTIFY',
};
export const Link_Target = {
    SELF: 'SELF',
    BLANK: 'BLANK',
    PARENT: 'PARENT',
    TOP: 'TOP',
};
export const PluginContainerData_Alignment = {
    CENTER: 'CENTER',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
};
export const PluginContainerData_Width_Type = {
    CONTENT: 'CONTENT',
    SMALL: 'SMALL',
    ORIGINAL: 'ORIGINAL',
    FULL_WIDTH: 'FULL_WIDTH',
};
export const Decoration_Type = {
    BOLD: 'BOLD',
    ITALIC: 'ITALIC',
    UNDERLINE: 'UNDERLINE',
    SPOILER: 'SPOILER',
    ANCHOR: 'ANCHOR',
    MENTION: 'MENTION',
    LINK: 'LINK',
    COLOR: 'COLOR',
    FONT_SIZE: 'FONT_SIZE',
};
export const FontSizeData_fontType = {
    PX: 'PX',
    EM: 'EM',
};
export const AppEmbedData_AppType = {
    PRODUCT: 'PRODUCT',
    EVENT: 'EVENT',
    BOOKING: 'BOOKING',
};
export const ButtonData_Type = {
    LINK: 'LINK',
    ACTION: 'ACTION',
};
export const CollapsibleListData_Direction = {
    LTR: 'LTR',
    RTL: 'RTL',
};
export const DividerData_LineStyle = {
    SINGLE: 'SINGLE',
    DOUBLE: 'DOUBLE',
    DASHED: 'DASHED',
    DOTTED: 'DOTTED',
};
export const DividerData_Width = {
    LARGE: 'LARGE',
    MEDIUM: 'MEDIUM',
    SMALL: 'SMALL',
};
export const DividerData_Alignment = {
    CENTER: 'CENTER',
    LEFT: 'LEFT',
    RIGHT: 'RIGHT',
};
export const FileData_PDFSettings_ViewMode = {
    NONE: 'NONE',
    FULL: 'FULL',
    MINI: 'MINI',
};
export const GalleryOptions_Layout_Type = {
    COLLAGE: 'COLLAGE',
    MASONRY: 'MASONRY',
    GRID: 'GRID',
    THUMBNAIL: 'THUMBNAIL',
    SLIDER: 'SLIDER',
    SLIDESHOW: 'SLIDESHOW',
    PANORAMA: 'PANORAMA',
    COLUMN: 'COLUMN',
    MAGIC: 'MAGIC',
    FULLSIZE: 'FULLSIZE',
};
export const GalleryOptions_Layout_Orientation = {
    ROWS: 'ROWS',
    COLUMNS: 'COLUMNS',
};
export const GalleryOptions_ItemStyle_Crop = {
    FILL: 'FILL',
    FIT: 'FIT',
};
export const GalleryOptions_Thumbnails_Alignment = {
    TOP: 'TOP',
    RIGHT: 'RIGHT',
    BOTTOM: 'BOTTOM',
    LEFT: 'LEFT',
    NONE: 'NONE',
};
export const HTMLData_Source = {
    HTML: 'HTML',
    ADSENSE: 'ADSENSE',
};
export const PollData_Poll_Settings_Permissions_ViewRole = {
    CREATOR: 'CREATOR',
    VOTERS: 'VOTERS',
    EVERYONE: 'EVERYONE',
};
export const PollData_Poll_Settings_Permissions_VoteRole = {
    SITE_MEMBERS: 'SITE_MEMBERS',
    ALL: 'ALL',
};
export const PollData_Layout_PollLayout_Type = {
    LIST: 'LIST',
    GRID: 'GRID',
};
export const PollData_Layout_PollLayout_Direction = {
    LTR: 'LTR',
    RTL: 'RTL',
};
export const PollData_Design_PollDesign_Background_Type = {
    COLOR: 'COLOR',
    IMAGE: 'IMAGE',
    GRADIENT: 'GRADIENT',
};
export const TableCellData_VerticalAlignment = {
    TOP: 'TOP',
    MIDDLE: 'MIDDLE',
    BOTTOM: 'BOTTOM',
};
export const LATEST_VERSION = 1;
export const RicosDocumentNodeType = {
    PARAGRAPH: 'PARAGRAPH',
    TEXT: 'TEXT',
    HEADING: 'HEADING',
    BULLETED_LIST: 'BULLETED_LIST',
    ORDERED_LIST: 'ORDERED_LIST',
    LIST_ITEM: 'LIST_ITEM',
    BLOCKQUOTE: 'BLOCKQUOTE',
    CODE_BLOCK: 'CODE_BLOCK',
    VIDEO: 'VIDEO',
    DIVIDER: 'DIVIDER',
    FILE: 'FILE',
    GALLERY: 'GALLERY',
    GIF: 'GIF',
    HTML: 'HTML',
    IMAGE: 'IMAGE',
    LINK_PREVIEW: 'LINK_PREVIEW',
    POLL: 'POLL',
    APP_EMBED: 'APP_EMBED',
    BUTTON: 'BUTTON',
    COLLAPSIBLE_LIST: 'COLLAPSIBLE_LIST',
    COLLAPSIBLE_ITEM: 'COLLAPSIBLE_ITEM',
    COLLAPSIBLE_ITEM_TITLE: 'COLLAPSIBLE_ITEM_TITLE',
    COLLAPSIBLE_ITEM_BODY: 'COLLAPSIBLE_ITEM_BODY',
    TABLE: 'TABLE',
    EMBED: 'EMBED',
    TABLE_CELL: 'TABLE_CELL',
    TABLE_ROW: 'TABLE_ROW',
    EXTERNAL: 'EXTERNAL',
    AUDIO: 'AUDIO',
};
export const RichContent = {
    fromJSON: (content) => {
        return content;
    },
    toJSON: (content) => {
        return content;
    },
};
export const Node_Type = RicosDocumentNodeType;
//# sourceMappingURL=ricos_document.js.map